import GenericDB from './generic-db'

export default class CommentsThread extends GenericDB {
  constructor() {
    super(`commentsThread`)
  }
  // Here you can extend CommentsThread with custom methods
}
